import { Action } from '@ngrx/store'
import { LoggedVendorUserV1 } from '../../../../api/api/models/logged-vendor-user-v1'
import { VendorConversationTeamV1 } from '../../../../api/api/models/vendor-conversation-team-v1'

// load
export const LOAD_CONVERSATION_TEAMS = '[ConvTeam] load'
export const LOAD_CONVERSATION_TEAMS_SUCCESS = '[ConvTeam] load success'
export const LOAD_CONVERSATION_TEAM = '[ConvTeam] load one'
export const LOAD_CONVERSATION_TEAM_SUCCESS = '[ConvTeam] load one success'
// remove
export const REMOVE_CONVERSATION_TEAM = '[ConvTeam] remove'
export const REMOVE_TEAM_MEMBER = '[ConvTeam] remove teamMember'
// misc
export const SWITCH_TEAM = '[ConvTeam] switch team'
export const CONVERSATIONS_LOADED = '[Team] conversations loaded'
export const INCREMENT_CONVERSATIONS = '[Team] inc conversations'
export const DECREMENT_CONVERSATIONS = '[Team] dec conversations'
export const NEW_MESSAGE = '[Team] New message'
export const UPDATE_ASSIGNED_CONVERSATION_TO_TEAM_MEMBER = '[Team] update assigned conv'

// load
export class LoadConversationTeams implements Action {
  readonly type = LOAD_CONVERSATION_TEAMS
}

export class LoadConversationTeamsSuccess implements Action {
  readonly type = LOAD_CONVERSATION_TEAMS_SUCCESS

  constructor(public payload: { teams: VendorConversationTeamV1[], me: LoggedVendorUserV1 }) {
  }
}

export class LoadConversationTeam implements Action {
  readonly type = LOAD_CONVERSATION_TEAM

  constructor(public payload: { vendorTeamId: number }) {
  }
}

export class LoadConversationTeamSuccess implements Action {
  readonly type = LOAD_CONVERSATION_TEAM_SUCCESS

  constructor(public payload: { team: VendorConversationTeamV1 }) {
  }
}

export class SwitchTeam implements Action {
  readonly type = SWITCH_TEAM

  constructor(public payload: { vendorTeamId: number }) {
  }
}

// remove
export class RemoveConversationTeam implements Action {
  readonly type = REMOVE_CONVERSATION_TEAM

  constructor(public payload: { vendorTeamId: number }) {
  }
}

export class RemoveTeamMember implements Action {
  readonly type = REMOVE_TEAM_MEMBER

  constructor(public payload: { vendorTeamId: number, vendorUserId: number }) {
  }
}

// misc
export class ConversationsLoaded implements Action {
  readonly type = CONVERSATIONS_LOADED

  constructor(public payload: { vendorTeamId: number, count: number, open: boolean }) {
  }
}

export class IncrementConversation implements Action {
  readonly type = INCREMENT_CONVERSATIONS

  constructor(public payload: { vendorTeamId: number }) {
  }
}

export class DecrementConversations implements Action {
  readonly type = DECREMENT_CONVERSATIONS

  constructor(public payload: { vendorTeamId: number }) {
  }
}

export class NewMessage implements Action {
  readonly type = NEW_MESSAGE

  constructor(public payload: { vendorTeamId: number, newMessage: boolean }) {
  }
}

export class UpdateAssignedConversationToTeamMember implements Action {
  readonly type = UPDATE_ASSIGNED_CONVERSATION_TO_TEAM_MEMBER

  constructor(public payload: { vendorTeamId: number, vendorUserId: number, increment: boolean }) {
  }
}

export type ConversationTeamActions =
  LoadConversationTeams
  | LoadConversationTeamsSuccess
  | LoadConversationTeam
  | LoadConversationTeamSuccess
  | RemoveConversationTeam
  | RemoveTeamMember
  | ConversationsLoaded
  | IncrementConversation
  | DecrementConversations
  | NewMessage
  | SwitchTeam
  | UpdateAssignedConversationToTeamMember



// WEBPACK FOOTER //
// ./src/app/shared/team/store/actions/conversation-team.actions.ts